module.exports = __webpack_public_path__ + "img/ic-permission.40487235.png";